<template>
  <v-card>
    <template v-if="service">
      <v-card-title>{{ $t('pages.serviceedition.title', service) }}</v-card-title>
      <v-card-text>
        <service-form
          :service="service">
        </service-form>
      </v-card-text>
    </template>
    <v-progress-linear v-else :indeterminate="true" height="2"></v-progress-linear>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { ServiceForm } from '@/components/service'
  export default {
    components: {
      ServiceForm
    },
    props: {
      id: Number,
      required: true
    },
    computed: {
      ...mapGetters({
        services: 'skiliko/services/collection'
      }),
      service () {
        return this.services[this.id]
      }
    },
    methods: mapActions({
      fetch: 'skiliko/services/fetch'
    }),
    mounted () {
      this.fetch({ id: this.id })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/ServiceEdition.vue